import React, { useState, useEffect } from "react";

import Card from "./Card";

export default function CardsFeedSection({
    filteredCards,
    selectedFilters,
    icons,
}) {
    const cardsPerPage = 6;

    // Init state.
    const [loadMoreVals, setLoadMoreVals] = useState({
        pageNum: 1,
        displayed: [],
        chunk: [],
        allShown: false,
    });

    /**
     * This resets the loadMoreVals state.
     * Needs to happen any time there's a new set of filtered cards.
     */
    useEffect(() => {
        setLoadMoreVals({
            pageNum: 1,
            displayed: [],
            chunk: [],
            allShown: false,
        });

    }, [filteredCards]);

    /**
     * Event handlers.
     */

    const handleLoadMoreBtn = (event) => {
        event.preventDefault();

        calcNextChunk();
    };

    // - - - - - - - - - -  Helper Functions  - - - - - - - - - -
    function calcNextChunk() {
        let cardsArr, chunk, allShown, nextDisplayed;

        cardsArr = getCardsArr();

        let start = loadMoreVals.pageNum * cardsPerPage;
        let end = start + cardsPerPage;

        if (end < cardsArr.length) {
            chunk = cardsArr.slice(start, end).map((item) => item.post_id);
            allShown = false;
        } else {
            chunk = cardsArr.slice(start).map((item) => item.post_id);
            allShown = true;
        }

        if (loadMoreVals.pageNum == 1) {
            // First load
            let displayedIni = cardsArr.slice(0, cardsPerPage).map((item) => item.post_id);

            nextDisplayed = displayedIni.concat(chunk);
        } else {
            nextDisplayed = loadMoreVals.displayed.concat(chunk);
        }

        let newState = {
            pageNum: (loadMoreVals.pageNum + 1),
            displayed: nextDisplayed,
            chunk: chunk,
            allShown: allShown,
        };

        console.log("New state", newState);
        setLoadMoreVals(newState);
    }

    function getCardsArr() {
        if (filteredCards.length) {
            return [...filteredCards];
        }
    }

    function getIniHiddenCards() {
        if (filteredCards.length) {
            return [...filteredCards]
                .slice(cardsPerPage)
                .map((item) => item.post_id);
        }
    }

    // Cards hidden on the first load.
    let iniHiddenCards = getIniHiddenCards();

    // Render JSX.
    return (
        <>
            <div className="container">
                {filteredCards.length === 0 && selectedFilters.is_filtered ? (
                    <p className="no-found-result">
                        We're sorry, we don't have any events that match your
                        search criteria.
                    </p>
                ) : null}

                <h3 className="section__heading">Explore what's on</h3>

                <div className="feed_cards grid">
                    {filteredCards.length
                        ? filteredCards.map((cardData, index) => (
                              <Card
                                  key={index}
                                  cardData={cardData}
                                  icons={icons}
                                  index={index}
                                  iniHiddenCards={iniHiddenCards}
                                  loadMoreVals={loadMoreVals}
                              />
                          ))
                        : null}
                </div>

                {filteredCards?.length > cardsPerPage && !loadMoreVals.allShown? (
                    <button
                        className="btn--alt btn--mask-icon-after btn--icon--arrow"
                        onClick={handleLoadMoreBtn}
                    >
                        Load more
                    </button>
                ) : null}
            </div>
        </>
    );
}
